module.exports = __webpack_public_path__ + "img/base-colours.25e69483.png";